import { PAWN_COLOURS, type PawnColour } from '@root/lib/pawnColour';

// Texture keys are the bare asset filenames. See buildRegistry.

export function diceFaceKey(face: number): string {
  return `DiceFace${face}`;
}

// Art that exists once per board colour.
const PER_COLOUR = [
  'Pawn',
  'Tile',
  'TileBox',
  'Crown',
  'DiceFrame',
  'EndZoneTriangle',
  'StartingArea',
  'GhostBoard_Oriented',
  'Board_QuadrantAtFullOpacity',
] as const;

// Multiplier tiles are a star with the value laid over it. The screenshot
// pairs 2X with the purple star and 3X with the gold one.
export const MULTIPLIER_ART: Record<number, { star: string; text: string }> = {
  2: { star: 'Star_Purple', text: 'MultiplierText_2X' },
  3: { star: 'Star_Gold', text: 'MultiplierText_3X' },
};

export const SHARED_TEXTURES: string[] = [
  'Background',
  'Background_Mobile',
  'Tile_Ivory',
  'TileBox_Frame',
  'FinishLine',
  'GhostBoard',
  'FullBoard_Preparing_FourStartingAreas',
  'PermanentRouteArrow_EntryDown',
  'PermanentRouteArrow_TurnUp',
  'Skull',
  'FreeRoll_Marker',
  'Star_Gold',
  'Star_Purple',
  'MultiplierText_2X',
  'MultiplierText_3X',
  ...[1, 2, 3, 4, 5, 6].map(diceFaceKey),
];

// Only the colour in play is worth downloading. Loading all four pulled
// ~1.5 MB of art the player never sees, most of it the ghost boards.
export function colourTextures(colour: PawnColour): string[] {
  return PER_COLOUR.map((base) => `${base}_${colour}`);
}

// Every texture across every colour. Used by the asset test, not at runtime.
export const BOARD_TEXTURES: string[] = [
  ...SHARED_TEXTURES,
  ...PAWN_COLOURS.flatMap(colourTextures),
];
